module.exports = __webpack_public_path__ + "static/a-tale-of-two-cities-c1edb8fdfe422763520924796fbd5e76.jpg";